// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"76bece53","869":"f67af5a7"}[chunkId] + ".chunk.js";
};